import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import API from '@/app-core/api/Api'
import CatalogProductListItem from '@/app-theme/components/store/CatalogProductListItem.vue'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'
import Translatable from '@/app-core/mixins/translatable'
import TagCommon from '@/app-core/mixins/tag/tagCommon'
import StoreCommon from '@/app-core/mixins/store/storeCommon'
import SelectTagDialog from '@/app-theme/views/tag/SelectTagDialog.vue'

export default {
  name      : 'Tag',
  components: {
    SelectTagDialog,
    CatalogProductListItem
  },
  directives: {},
  mixins    : [i18nRouteMeta, Translatable, TagCommon, StoreCommon],
  props     : {},
  enums     : {},
  dataStore : {
    AppCart: 'App.Cart',
    AppTags: 'App.Tags',
    TagInfo: 'Tag.Info',
    TagMenu: 'Tag.Menu'
  },
  data() {
    return {
      title           : '',
      description     : '',
      tag             : null,
      slug            : null,
      id              : null,
      isLoading       : false,
      tagDialogVisible: false
    }
  },
  computed: {
    tagMenuItems() {
      return this.TagMenu[this.id] || []
    },
    hasTagMenuItems() {
      return !!this.tagMenuItems.length
    }
  },
  watch: {
    '$route.params.id': {
      handler(val) {
        this.initView()
      },
      immediate: false
    }
  },
  beforeCreate() {
  },
  created() {
    this.$bus.$emit('cart:get-data')

    this.$bus.$on('show:select-tag', this.showSelectTagDialog)
    this.$bus.$on('tag:selected', this.onTagSelected)
    this.$bus.$on('tag:init-menu', this.initView)
    this.$bus.$on('tag:get-menu', this.getData)

    this.initView()
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off('show:select-tag', this.showSelectTagDialog)
    this.$bus.$off('tag:selected', this.onTagSelected)
    this.$bus.$off('tag:init-menu', this.initView)
    this.$bus.$off('tag:get-menu', this.getData)
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase,
    initView() {
      this.slug = this.$route.params?.slug
      this.id = this.$route.params?.id

      this.TagInfo = this.AppTags?.find(tag => parseInt(tag.Id) === parseInt(this.id))
      this.title = this.getTranslatedField(this.TagInfo, 'Label')
      this.description = this.getTranslatedField(this.TagInfo, 'Description')

      this.getData()
    },

    getData() {
      if (!this.id) return

      this.isLoading = true

      API.Resource.Tag.Menu(this.id)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            this.$set(this.TagMenu, this.id, API.responseData(response))
          } else {
            this.$set(this.TagMenu, this.id, null)
          }
        })
        .catch(e => {
          this.TagMenu[this.id] = null
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    showSelectTagDialog() {
      this.tagDialogVisible = true
    },

    onTagSelected(tag) {
      if (!tag || this.$route.params.id === tag.Id) return

      this.$router.push({
        name  : 'Tag',
        params: {
          slug: this.getTranslatedField(tag, 'Slug'),
          id  : tag.Id
        }
      })
    },

    onScroll() {
      const offsetTop = 144

      const elements = [...this.$refs.container.children]
      elements.forEach(el => {
        const elementRect = el.getBoundingClientRect()
        if (elementRect.top < offsetTop) {
          this.$bus.$emit('store:select', el.id)
        }
      })
    }

  }
}
